import React from "react";
import { Text } from "@chakra-ui/react";

const TermsAndPrivacy: React.FC = () => {
  return (
    <Text
      maxWidth="400px"
      width="calc(100% - 24px)"
      textAlign="center"
      fontSize="14px"
      color="gray.600"
      lineHeight="18px"
      fontWeight={400}
      pb={4}
    >
      By continuing, you agree to these{" "}
      <a
        href="https://sophon.xyz/terms"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007AFF", textDecoration: "underline" }}
      >
        Terms of Service
      </a>{" "}
      and{" "}
      <a
        href="https://sophon.xyz/privacypolicy"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007AFF", textDecoration: "underline" }}
      >
        Privacy Policy
      </a>
      .
    </Text>
  );
};

export default TermsAndPrivacy;